import { fromServerIsoString } from '@se/platform';
import moment, { isMoment, Moment } from 'moment';
import { MomentParams, ToISOStringParams } from './interfaces';
import { EDateFuncion } from '@se/cp.common';

export const parseToMoment = (value: Date | string): Moment | null => {
    const date = typeof value === 'string' ? fromServerIsoString(value) : moment(value);
    if (date.isValid()) return date;
    return null;
};

export const parseToISOString = (value: Date | Moment): string | null => {
    if (value instanceof Date) return value.toJSON();
    if (isMoment(value) && value.isValid()) return value.utc(false).toDate().toJSON();
    return null;
};

export const seToday = () => {
    return moment().startOf('day').toDate();
};

export const dateFunctionMap: Record<EDateFuncion, (...args: any[]) => any> = {
    MOMENT: (params: MomentParams) => parseToMoment(...params),
    TO_ISO_STRING: (params: ToISOStringParams) => parseToISOString(...params),
    SE_TODAY: () => seToday(),
};
